import { render, staticRenderFns } from "./PodtEditPlmtrl.vue?vue&type=template&id=9157ea4e&scoped=true&"
import script from "./PodtEditPlmtrl.vue?vue&type=script&lang=js&"
export * from "./PodtEditPlmtrl.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditPlmtrl.vue?vue&type=style&index=0&id=9157ea4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9157ea4e",
  null
  
)

export default component.exports